// Retry payloads for failed AI-processing items, keyed by taskId.
//
// The original submission (image File objects, hint, concern level, etc.) is
// needed to replay a failed create/update, but File objects aren't
// serializable so they can't live in Redux. This module-level registry holds
// them outside the store; the failed card/widget only need the taskId to look
// a payload up and re-fire it. Entries are dropped once consumed or dismissed
// so they don't leak across the session.

const payloads = new Map();

// kind: "create" (replay aiGenerateItem in existing-item mode) or
// "edit" (replay aiUpdateItem). args is the exact thunk argument object.
export const registerRetryPayload = (taskId, payload) => {
  if (!taskId || !payload) return;
  payloads.set(taskId, payload);
};

export const getRetryPayload = (taskId) => payloads.get(taskId) || null;

export const clearRetryPayload = (taskId) => {
  payloads.delete(taskId);
};
